<template>
  <Form 
    :d_form='form'
    :d_lkp_negara='lkp_negara'
    :d_se_katalog='se_katalog'
    :id='id'
    v-if="id > 0"
  /> 
  <Form 
    :d_form='form'
    :d_lkp_negara='lkp_negara'
    :d_se_katalog='se_katalog'
    :id='id'
    v-else-if="id == 0"
  /> 
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'
import Form from "./_From.vue";

export default {
  extends: ZResource,
  components: {
    Form
  },
  props: {
    id: [Array, Object],
  },
  data() {
    return {
      resourceurl: 'se.perekodan',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Pengurusan Semen Beku', route: '/se' },
        { label: 'Pemungutan Pendaftaran Import', route: '/se/perekodan' },
      ],
      title : 'Tambah Baka Jantan',
      form : {
        id : 0,
        tarikh : '',
        no_batch: '',
        tarikh_pengeluaran : '',
        id_ternakan : '',
        nama_ternakan: '',
        baka: '',
        negara : '',
        jumlah_straw: '',
        se_katalog_id: '',
        nama_pengeluar_s: '',
        harga:0,
        hantar: 2
      },
      form1:[],
      se_pengeluaran : [],
      lkp_negara: [],
      negeri: [],
      se_katalog: [],
      load : 0
      
      
    }
  },
  methods: {
    
 
    getData(){
      if(this.id > 0){
        this.$zcomm.get(this.api_service + 'se_pendaftaran/show/'+this.id, {}).then(res => {
          this.form = res
          this.load = this.load + 1

        })
      }
    },
    getNegara(){
      this.$zcomm.get(this.api_service + 'lookup/negara', {}).then(res => {
        this.lkp_negara = res
        this.load = this.load + 1
      })
    },
    getKatalog(){
      this.$zcomm.get(this.api_service + 'lookup/se_katalog_luar', {}).then(res => {
        this.se_katalog = res
        this.load = this.load + 1
      })
   },
  
  },

  watch: {

  },
  mounted() {
    this.getData();
    this.getNegara();
    this.getKatalog();
    // this.getGetnoBatch()
    
  }
    
}
</script>
